import Vue from 'vue';
import { abilitiesPlugin, Can } from '@casl/vue';

import store from '@/store';

Vue.use(abilitiesPlugin, store.getters['user/ability']);

Vue.component('Can', Can);
